import React from 'react'
import { Message } from 'rsuite'

export default function WarningMessage({ message, style, closable, ...props }) {
  let styles = { marginBottom: 10, marginTop: 10 }
  if (style) {
    styles = { ...styles, ...style }
  }
  if (message) {
    return (
      <Message closable={closable} style={styles} showIcon type="warning" description={message} />
    )
  }
  return null
}
